import { a as t } from "./an-object.js";
import { i as r } from "./iterator-close.js";
var o = function o(_o, a, i, c) {
  try {
    return c ? a(t(i)[0], i[1]) : a(i);
  } catch (t) {
    r(_o, "throw", t);
  }
};
export { o as c };